<template>
  <div>
    <div class="top">
      <TopContent />
    </div>
    <div v-if="!isMobile" class="pc-sections">
      <div class="aboutUs_bg"></div>
      <div class="aboutUs_con">
        <div class="proTit">
          <div class="tittext fontsize2">关于我们</div>
          <div class="blue"></div>
        </div>
        <div class="aboutUs_img"><img src="../../assets/img/About_doc.png" /></div>
        <p class="fontsize1">
          云南启秘科技有限公司致力于通过大数据技术、互联网技术和数字医疗技术发现社会群体健康和个人身体健康的规律、
          问题以及相关性，从而精准地指与群体健康管理和个人健康管理，改善全民健康，造福社会。<br><br>
          启秘创始人及其团队从1998年开始从事医学影像分析课题研究，2000年之后完全专注于数字医疗技术的研究与应用，
          有力地推动了云南省等地区的医字影像数字化应用的发展。20年的努力耕耘，掌握了该领域的主要核心技术，
          形成了以【通】(互联网大数据推送系统)、【智】(医疗健康大数据自动分析系统)、
          【合】(医疗健康数据应用集成系统)为代表的拥有专利技术的系统平台，
          建立了一条以通、智、合为基础的数字医疗健康发展路线。
          同时长年在该领域的研发积累和整合形成了全面的数字医疗技术支撑产品体系，以及全面的知识产权体系。<br><br>
          启秘科技是一个技术平
          台公司，以通、智、合为核心的医疗健康数字化技术支撑产品和经验丰富的技术团队能够有效地支撑
          医疗健康业互联网应用发展,并且由于强大的核心技术以及全面具有一致性支撑产品，保证各个应用具有
          独特的竞争力。典型的应用包括超声在线、影像云、大数据精准健康管理平台、医疗信息与设备技术服务、
          智慧医疗、医生工作室服务平台、智慧养老等，一个产业生态圈正在形成。
        </p>
        <div class="aboutUs_product"><img src="../../assets/img/About_product.png" /></div>
        <p class="fontsize1">
          <span class="conTit">团队优势</span><br>
          1、专业化水平高<br>
          团队具有二十年数字医疗研发的历程，积累了丰富的技术成果及实践经验。所研发的医疗数据应用集成系统(平台)达到国内领先水平，
          医疗影像大数据女理与传输关键技术达到国际先进水平，
          先后获得云南省科技进步奖和技术发明奖，相关产品功能全面、方便实用、运行稳定、效果显著。<br><br>
          2、标准化应用自如<br>
          团队对国际国内数十项医疗健康相关标准与规范十分熟悉，应用自如，轻松解决绝大部分国际国内所生产医疗仪器设备的互联互通。<br><br>
          3、集成互联能力强<br>
          团队对医院现有的医疗仪器、设备、系统基本上都能集成互联，我们研发的互联网大数据推送系统可以安全、可靠、
          高效地实现从省级到州市级到县区级再到乡镇社区各级医疗卫生服务机构的海量信息传输，真正实现纵向横向的医疗健康信息互联互通，打破了医疗健康信息孤岛。<br><br>
          4、本地化全程支持<br>
          我们对本土医疗健康信息化建设最具有责任心，可以常驻现场维护，及时解决问题，确保平台运行稳定，不断完善。
          这也是医疗信息化项目建设成功的重要条件。<br><br>
        </p>
      </div>
    </div>
    <div v-else class="mobile-sections">
      <div class="m_con_bg maboutUs_bg"></div>
      <div class="m_con">
        <div class="m_bule_div">
          <div class="blue_tit">关于我们</div>
          <div class="blue_color blue_div"></div>
        </div>
        <div class="m_aboutUs">
          <div class="m_aboutUs_img">
            <img src="../../assets/img/About_doc.png" />
          </div>
          <p>
            云南启秘科技有限公司致力于通过大数据技术、互联网技术和数字医疗技术发现社会群体健康和个人身体健康的规律、
            问题以及相关性，从而精准地指与群体健康管理和个人健康管理，改善全民健康，造福社会。<br><br>
            启秘创始人及其团队从1998年开始从事医学影像分析课题研究，2000年之后完全专注于数字医疗技术的研究与应用，
            有力地推动了云南省等地区的医字影像数字化应用的发展。20年的努力耕耘，掌握了该领域的主要核心技术，
            形成了以【通】(互联网大数据推送系统)、【智】(医疗健康大数据自动分析系统)、
            【合】(医疗健康数据应用集成系统)为代表的拥有专利技术的系统平台，
            建立了一条以通、智、合为基础的数字医疗健康发展路线。
            同时长年在该领域的研发积累和整合形成了全面的数字医疗技术支撑产品体系，以及全面的知识产权体系。<br><br>
            启秘科技是一个技术平
            台公司，以通、智、合为核心的医疗健康数字化技术支撑产品和经验丰富的技术团队能够有效地支撑
            医疗健康业互联网应用发展,并且由于强大的核心技术以及全面具有一致性支撑产品，保证各个应用具有
            独特的竞争力。典型的应用包括超声在线、影像云、大数据精准健康管理平台、医疗信息与设备技术服务、
            智慧医疗、医生工作室服务平台、智慧养老等，一个产业生态圈正在形成。
          </p>
          <div class="m_aboutUs_product"><img src="../../assets/img/About_product.png" /></div>
          <p>
            <span class="conTit">团队优势</span><br>
            1、专业化水平高<br>
            团队具有二十年数字医疗研发的历程，积累了丰富的技术成果及实践经验。所研发的医疗数据应用集成系统(平台)达到国内领先水平，
            医疗影像大数据女理与传输关键技术达到国际先进水平，
            先后获得云南省科技进步奖和技术发明奖，相关产品功能全面、方便实用、运行稳定、效果显著。<br><br>
            2、标准化应用自如<br>
            团队对国际国内数十项医疗健康相关标准与规范十分熟悉，应用自如，轻松解决绝大部分国际国内所生产医疗仪器设备的互联互通。<br><br>
            3、集成互联能力强<br>
            团队对医院现有的医疗仪器、设备、系统基本上都能集成互联，我们研发的互联网大数据推送系统可以安全、可靠、
            高效地实现从省级到州市级到县区级再到乡镇社区各级医疗卫生服务机构的海量信息传输，真正实现纵向横向的医疗健康信息互联互通，打破了医疗健康信息孤岛。<br><br>
            4、本地化全程支持<br>
            我们对本土医疗健康信息化建设最具有责任心，可以常驻现场维护，及时解决问题，确保平台运行稳定，不断完善。
            这也是医疗信息化项目建设成功的重要条件。<br><br>
          </p>
        </div>
      </div>
    </div>
    <div class="bottom">
      <BottomContent />
    </div>
  </div>
</template>
<script>
import TopContent from "@/components/Top/index.vue";
import BottomContent from "@/components/Bottom/index.vue";
export default {
  components: { TopContent, BottomContent },
  data () {
    return {

    }
  },
  computed: {
    isMobile () {
      return window.innerWidth <= 1439;
    },
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted () {
    window.addEventListener('resize', this.handleResize);
    this.load();
  },
  methods: {
    handleResize () {
      this.$forceUpdate();
    },
    load () {
      if (document && document.body) {
        document.body.style.margin = '0px';
        this.originalBodyMargin = document.body.style.margin;
      }
    },
  },
}
</script>
<style lang="scss" src="../../assets/css/PC.scss" scoped></style>
<style lang="scss" scoped>
.mobile-sections {
  display: none;
}

.bottom {
  height: 70px;
}

.aboutUs_bg {
  background-image: url("../../assets/img/About_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 70vh;
}

.maboutUs_bg {
  background-image: url("../../assets/img/About_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}

.fontsize1 {
  font-size: 19px;
}

.fontsize2 {
  font-size: 24px;
}

.aboutUs_con {
  width: 70%;
  margin: 0px auto 50px auto;

  .proTit {
    height: 15vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .tittext {
      font-weight: bold;
    }

    .whiteFont {
      color: white;
    }

    .blue {
      background-color: #0073d3;
      width: 150px;
      height: 7px;
      margin: 15px 0px;
    }
  }

  .aboutUs_img {
    display: flex;
    justify-content: center;
    height: 30vh;

    img {
      max-width: 100%;
      height: 100%;
    }
  }

  .aboutUs_product {
    display: flex;
    justify-content: center;
    height: 50vh;

    img {
      max-width: 100%;
      height: 100%;
    }
  }

  .conTit {
    font-weight: 600;
  }
}

@media (max-width: 1439px) and (min-width: 10px) {
  .pc-sections {
    display: none;
  }

  .mobile-sections {
    width: 100%;
    font-size: 15px;
    display: block;
    overflow-x: hidden; // padding-top: 70px;

    .m_con_bg {
      width: 100%;
      height: 30vh;

    }

    .m_con {
      width: 90%;
      margin: auto;
      // height: 90vh;
      padding: 3vh;
      // overflow-y: auto;
    }

    .m_bule_div {
      display: flex;
      flex-direction: column;
      align-items: center;

      .blue_tit {
        font-weight: 500;
      }

      .blue_div {
        margin-top: 5px;
        width: 80px;
        height: 5px;
      }

      .blue_color {
        background-color: #0073d3
      }

      .white_color {
        background-color: white
      }

      .white_text {
        color: white
      }
    }

    .conTit {
      font-weight: 600;
    }

    .m_aboutUs_img {
      width: 100%;
      margin: 15px auto;

      img {
        max-width: 100%;
        height: 100%;
      }
    }

    .m_aboutUs_product {
      width: 100%;
      margin: 15px auto;

      img {
        max-width: 100%;
        height: 100%;
      }
    }
  }
}
</style>